import { Routes, Route, useLocation } from 'react-router-dom';
import { useEffect } from 'react';

import './App.css';
import Home from './pages/home/Home';
import About from './pages/about/about';
import Header from './components/header';
import Footer from './components/footer';
import Contact from './pages/contact/contact';
import Service from './pages/services/services';
import AppDevelopment from './pages/individual-services/app-development/app-development';
import ProjectSupport from './pages/individual-services/project-support/project-support';
import SupportAndMaintenance from './pages/individual-services/support-maintenance/support-maintenance';
import WebDevelopment from './pages/individual-services/web-development/web-development';
import SoftwareDevelopment from './pages/individual-services/software-development/software-development';
import { gsap, Power3 } from 'gsap';




function App() {
  // GSAP timeline and ease function
  var tl = gsap.timeline({ repeat: 0 });
  const ease = Power3.easeOut;
  const location = useLocation();

  useEffect(() => {
    document.documentElement.scrollTop = 0; // Sayfayı üstten başlat
  }, [location]);

  const isServicePage = location.pathname === '/services';
  const isAppDevelopmentPage = location.pathname === '/services/app-development';
  const isSupportAndMaintenancePage = location.pathname === '/services/support-and-maintenance';

  return (
    <div className="app">
      <Header
        isServicePage={isServicePage}
        isAppDevelopmentPage={isAppDevelopmentPage}
        isSupportAndMaintenancePage={isSupportAndMaintenancePage}
        timeline={tl} ease={ease} />

      
      <Routes>

        <Route path='/' element={<Home />} />
        <Route path='/about' element={<About />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/services' element={<Service />} />
        <Route path='/services/web-development' element={<WebDevelopment />} />
        <Route path='/services/software-development' element={<SoftwareDevelopment />} />
        <Route path='/services/project-support' element={<ProjectSupport />} />
        <Route path='/services/app-development' element={<AppDevelopment />} />
        <Route path='/services/support-and-maintenance' element={<SupportAndMaintenance />} />

      </Routes>
      <Footer />
    </div>
  );
}

export default App;
